export const API = {
  protocol: 'https://',
  ip: 'db.museudemanacor.com'
}

export const USER = {
  name: 'web',
  pass: 'museu'
}
